import styled from '@emotion/styled'
import { FlexCenter } from '@oneToOne/shared/styles'

export const RecordingStatementContainer = styled.div<{
  isOverlayOnChat: boolean
}>`
  ${FlexCenter}
  position: absolute;
  ${(props) => (props.isOverlayOnChat ? 'top: 440px' : 'bottom: 150px')};
  padding: 6px 0 6px 12px;
  background-color: var(--gray-8);
  border-radius: 4px;
  gap: 20px;
  white-space: normal;
  flex-grow: 1;
  max-width: 330px;
  z-index: 1;
`

export const RecordingStatementText = styled.span`
  font-size: 12px;
  color: var(--white);
  white-space: normal;
`
